import type {DataRouterBlobPayload} from '@github-ui/code-view-types'
import {repositoryTreePath} from '@github-ui/paths'
import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'
import {fileTreeQuery} from '../queries/file-tree-query'
import type {CodeViewPathParams} from '../queries/types/shared-query-types'
import {shouldParseCodeViewErrorResponse} from './code-view-error-response'

export function buildCodeViewBlobRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('codeViewBlobRoute', {
    path: '/:owner/:repo/blob/:branch/*',
    queries: [
      mainQuery<DataRouterBlobPayload>({
        queryDeps: ({params: routeParams, searchParams}) => {
          // React Router and TanStack Router have different pathname encoding contracts.
          // Build the encoded pathname from the raw route params to prevent double-encoding.
          const params = routeParams as CodeViewPathParams
          return {
            pathname: repositoryTreePath({
              repo: {ownerLogin: params.owner, name: params.repo},
              commitish: params.branch,
              action: 'blob',
              path: params['*'],
            }),
            searchParams: Object.fromEntries(searchParams),
          }
        },
        shouldParseErrorResponse: shouldParseCodeViewErrorResponse,
      }),
      fileTreeQuery,
    ],
    uiServiceOptions: {
      tsrConfig: {
        validateSearch: (search: Record<string, unknown>): {plain?: string; short_path?: string; h?: string} =>
          search as {plain?: string; short_path?: string; h?: string},
      },
    },
  })
}

export const codeViewBlobRoute = buildCodeViewBlobRoute(codeViewAppBuilder)
